import { render, staticRenderFns } from "./SectionCategoriesKpiCard.vue?vue&type=template&id=3d059878"
import script from "./SectionCategoriesKpiCard.vue?vue&type=script&lang=ts"
export * from "./SectionCategoriesKpiCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports